export default __webpack_public_path__ + "static/media/Logo_Default.78b0375a.svg";